import { CONST } from "../CONST";

export class SoundtrackScene extends Phaser.Scene{
    private music !: Phaser.Sound.BaseSound;

    constructor(){
        super({
            key: CONST.SCENES.SOUNDTRACK,
        })
    }

    create(){
        this.music = this.sound.add(CONST.AUDIO.SOUNDTRACK_SHORT, { loop: true, mute: false});
        this.music.play();
        
        this.registry.set(CONST.SCENES.SOUNDTRACK, this);
    }

    public pauseMusic(pause: boolean){
        if (pause) {
            this.music.pause();
        } else {
            this.music.resume();
        }
    }

    //Called when actual soundtrack is loaded
    public switchMusic(){
        var newMusic = this.sound.add(CONST.AUDIO.SOUNDTRACK, { loop: true, mute: false, seek: this.music.seek});
        newMusic.play();
        if (this.music.isPaused){
            newMusic.pause();
        }
        newMusic.setSeek(this.music.seek);
        this.music.stop();
        this.music = newMusic;
    }
}